import { showBanner } from './../template/template.js'
import './style.min.css'
import gsap from 'gsap'

const isFR = document.documentElement.lang == 'fr'

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const MONTHS_FR = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
const timelineContainer = document.querySelector('.timeline-container')
const selectorContainer = document.querySelector('.selector-container')
const future = {
    timeline: document.querySelector('.timeline.future-events'),
    selector: document.querySelector('.tl-time.future'),
    left: '100vw',
}
const past = {
    timeline: document.querySelector('.timeline.past-events'),
    selector: document.querySelector('.tl-time.past'),
    left: '-100vw',
}

// First timeline is shown, second is hidden
let order = [future, past]

future.selector.addEventListener('click', () => {
    order = [future, past]
    toggleTimeline(order, true)
})
past.selector.addEventListener('click', () => {
    order = [past, future]
    toggleTimeline(order, true)
})

/* -------- START GOOGLE CALENDAR -------- */
const GoogleCalendarAPIURL =
    'https://www.googleapis.com/calendar/v3/calendars/events.teamcoda@gmail.com/events?key=AIzaSyDbOnK6H7v-sOR5NpdviMrnzMw10CF8bMU&orderBy=startTime&singleEvents=true&maxResults=50'

// Send GET request
function httpGetAsync(timeMinMax, callback) {
    var xmlHttp = new XMLHttpRequest()
    xmlHttp.onreadystatechange = function () {
        // Check if request is done
        if (xmlHttp.readyState == 4) {
            // Check if request is successful
            if (xmlHttp.status == 200) {
                callback(JSON.parse(xmlHttp.response))
            }
            // Wait until the request is done before checking for error
            else {
                showBanner("We couldn't fetch the data :(", 'Une erreur est survenue :(', 0)
            }
        }
    }
    xmlHttp.open('GET', GoogleCalendarAPIURL + timeMinMax + new Date().toISOString(), true)
    xmlHttp.send(null)
}

// Send GET request to Google Calendar API for future events
httpGetAsync('&timeMin=', (futureCalendar) => {
    populateTimeline(future.timeline, futureCalendar.items)
    toggleTimeline([future, past])
})
// Send GET request to Google Calendar API for past events (in reverse order so closer events are first)
httpGetAsync('&timeMax=', (pastCalendar) => {
    populateTimeline(past.timeline, pastCalendar.items.reverse())
})
/* -------- END GOOGLE SHEETS -------- */

/* -------- START EVENTS ANIMATIONS -------- */
function populateTimeline(timeline, events) {
    if (events.length <= 0) {
        timeline.classList.toggle('empty', true)
    }
    for (let i = 0; i < events.length; i++) {
        let event = events[i]

        // Format date to be "Month Day, Year | Hour:Minute am/pm"
        let startDateTime = null
        if (event.start.dateTime) {
            let date = new Date(event.start.dateTime)
            startDateTime = `${date.toLocaleDateString(isFR ? 'fr-CA' : 'en-CA', { month: 'long', day: 'numeric', year: 'numeric' })} | ${date
                .toLocaleTimeString(isFR ? 'fr-CA' : 'en-CA', {
                    hour12: !isFR,
                    hour: 'numeric',
                    minute: '2-digit',
                })
                .replaceAll('.', '')}`
        } else if (event.start.date) {
            let dateParts = event.start.date.split('-')
            startDateTime = `${isFR ? MONTHS_FR[parseInt(dateParts[1]) - 1] : MONTHS[parseInt(dateParts[1]) - 1]} ${parseInt(dateParts[2])}, ${
                dateParts[0]
            }`
        }

        // Create event element and add details
        let eventElement = document.createElement('div')
        eventElement.classList.add('event')
        eventElement.innerHTML = `
            <div class="card-top">
                <div class="title">${event.summary ? event.summary : isFR ? 'Événement Coda' : 'Coda Event'}</div>
                <div class="time">${startDateTime}</div>
            </div>
            <div class="img-container">
                <div class="img-clip">
                    <img class="background" src="" alt="${event.attachments ? event.attachments[0].title : ''}" />
                    <div class="fg-container">
                        <img class="foreground" src="" alt="${event.attachments ? event.attachments[0].title : ''}" />
                    </div>
                </div>
                <div class="shadow"></div>
            </div>
            <div class="card-bottom">
                ${event.description ? event.description : ''}
                ${
                    // Create Google Maps Search URL with address if there is a location given
                    event.location
                        ? `<div class="location-container"><a
                    class="location"
                    href="https://www.google.ca/maps/place/${encodeURIComponent(
                        isNaN(event.location[0]) ? event.location.split(',').slice(1).join(',').trim() : event.location
                    )}"
                    target="_blank"
                    rel="noopener noreferrer"
                    >${event.location.split(',')[0] + '&#8288;'}</a
                ></div>`
                        : ''
                }
            </div>
        `
        timeline.appendChild(eventElement)

        // Get img elements
        event.imgBg = eventElement.querySelector('img.background')
        event.img = eventElement.querySelector('img.foreground')

        // Throttle scroll and resize events to fit framerate
        let ticking = false
        document.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    calculateImgPosition(i, events)
                    ticking = false
                })
                ticking = true
            }
        })
        window.addEventListener('resize', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    calculateImgPosition(i, events)
                    ticking = false
                })
                ticking = true
            }
        })

        // Load first two events only
        if (i < 2) {
            loadEventImage(i, events)
        }
    }
}

function loadEventImage(index, eventsArray) {
    // Set img src
    let img = eventsArray[index].img
    if (eventsArray[index].attachments) {
        eventsArray[index].imgBg.src = `https://drive.google.com/thumbnail?id=${eventsArray[index].attachments[0].fileId}&sz=w1080`
        img.src = `https://drive.google.com/thumbnail?id=${eventsArray[index].attachments[0].fileId}&sz=w1080`
    } else {
        eventsArray[index].imgBg.src = '/images/event-icon.jpg'
        img.src = '/images/event-icon.jpg'
    }
    img.loaded = true
}

function calculateImgPosition(index, eventsArray) {
    // Get img and bounding rectangle of img-clip
    let img = eventsArray[index].img
    let rect = img.parentElement.parentElement.getBoundingClientRect()
    // Check if img-clip in viewport
    let vpHeight = window.innerHeight || document.documentElement.clientHeight
    if (!(rect.bottom >= 0 && rect.right >= 0 && rect.top <= vpHeight && rect.left <= (window.innerWidth || document.documentElement.clientWidth)))
        return

    // Load the next event's image if it hasn't already been loaded
    let nextEvent = eventsArray[index + 2]
    if (nextEvent && !nextEvent.img.loaded) {
        loadEventImage(index + 2, eventsArray)
    }

    // Calculate pixel height of img translate (from 100vh - 100% to 0)
    let progress = Math.max(Math.min(rect.top / (vpHeight - rect.height), 1), 0)
    img.style.transform = `translate3d(0px, ${progress * (vpHeight - img.clientHeight)}px, 0px)`
}

function toggleTimeline([toShow, toHide], updatePosition = false) {
    // Toggle selected timeframe
    toShow.selector.classList.toggle('selected', true)
    toHide.selector.classList.toggle('selected', false)
    // If position needs to be updated
    if (updatePosition) {
        timelineContainer.scrollIntoView()
        // Animate timelines in and out of viewport
        gsap.to(toShow.timeline, {
            left: 0,
            duration: 0.5,
            ease: 'expo.inOut',
            overwrite: true,
        })
        gsap.to(toHide.timeline, {
            left: toHide.left,
            duration: 0.5,
            ease: 'expo.inOut',
            overwrite: true,
            onStart: () => {
                // Set the max height at the start so it doesn't crop the smaller timeline
                let maxHeight = Math.max(toShow.timeline.clientHeight, toHide.timeline.clientHeight)
                timelineContainer.style.height = maxHeight + 'px'
                selectorContainer.style.height = maxHeight + 'px'
            },
            onComplete: () => {
                // Reset height of timeline container (determines scroll height) and sticky element parent (allows sticky without being too tall and affecting scroll height)
                timelineContainer.style.height = toShow.timeline.clientHeight + 'px'
                selectorContainer.style.height = toShow.timeline.clientHeight + 'px'
            },
        })
        return
    }
    // Reset height of timeline container (determines scroll height) and sticky element parent (allows sticky without being too tall and affecting scroll height)
    timelineContainer.style.height = toShow.timeline.clientHeight + 'px'
    selectorContainer.style.height = toShow.timeline.clientHeight + 'px'
}
// Recalculate scroll height on resize
window.addEventListener('resize', () => {
    toggleTimeline(order)
})
// Refresh height to avoid bug
setTimeout(() => {
    toggleTimeline(order)
}, 1000)
/* -------- END EVENTS ANIMATIONS -------- */
